<template>
  <v-container>
    <v-row>
      <v-col cols="6" sm="4">
        <v-autocomplete
          variant="underlined"
          v-model="selectedDept"
          :items="departments"
          item-title="name"
          item-value="id"
          label="Выберите комплекс"
          @update:model-value="getMissedHours"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex align-center justify-center">
        <v-btn
          icon="mdi-arrow-left"
          size="x-small"
          variant="text"
          @click="decDate()"
        />

        <v-menu
          v-model="dateMenu"
          transition="scale-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ props }">
            <span v-bind="props" class="cursor-pointer">{{ dayStr }}</span>
          </template>

          <v-locale-provider locale="ru">
            <v-date-picker
              hide-header
              bg-color="grey-lighten-5"
              :max="semesterSettings?.end"
              :min="semesterSettings?.begin"
              v-model="selectedDate"
              no-title
              @update:modelValue="dateMenu = false"
            />
          </v-locale-provider>
        </v-menu>

        <v-btn
          icon="mdi-arrow-right"
          size="x-small"
          variant="text"
          @click="incDate()"
        />
      </v-col>
    </v-row>
    <!-- Итоги -->
    <v-row>
      <v-col cols="12" sm="8">
        <v-btn
          variant="text"
          icon="mdi-microsoft-excel"
          color="green darken-2"
          @click="printExcel"
        />
      </v-col>
      <v-col cols="12" class="d-flex align-center justify-left">
        <div style="font-weight: bold; margin-bottom: 8px">
          Итого студентов по всем группам:
        </div>
        <div
          v-for="col in attColumns"
          :key="col"
          style="margin: 6px 0; display: flex; align-items: center"
        >
          <span v-html="emojis[col]" style="margin-right: 6px"></span>
          <span style="margin-right: 4px">{{ col }}:</span>

          <span
            :style="{
              color: (totalAttendance[col] || 0) !== 0 ? '#FC8D1C' : '#BDBBBB',
              fontWeight: 'bold',
            }"
          >
            {{ totalAttendance[col] || 0 }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-data-table
      class="attendance-table"
      :headers="headers"
      :items="flatItems"
      :items-per-page="-1"
      hide-default-footer
      height="500"
      fixed-header
    >
      <template #item="{ item }">
        <!-- Группа -->
        <tr
          v-if="item.type === 'group'"
          class="group-row"
          @click="toggleGroup(item.groupid)"
          style="cursor: pointer"
        >
          <td colspan="2">
            <v-icon size="18" class="mr-2">
              {{
                isExpanded(item.groupid)
                  ? "mdi-chevron-down"
                  : "mdi-chevron-right"
              }}
            </v-icon>
            {{ item.group_name }}
          </td>
          <td v-for="col in attColumns" :key="col"></td>
        </tr>
        <!-- Студент -->
        <tr
          v-else-if="item.type === 'student'"
          v-show="isExpanded(item.groupid)"
        >
          <td></td>
          <td>{{ item.student_name }}</td>
          <td v-for="col in attColumns" :key="col">{{ item[col] || "" }}</td>
        </tr>
        <!-- Итог группы -->
        <tr
          v-else-if="item.type === 'total'"
          v-show="isExpanded(item.groupid)"
          class="font-weight-bold total-row"
        >
          <td colspan="2">Итого</td>
          <td v-for="col in attColumns" :key="col">{{ item[col] }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-overlay
      v-model="processData"
      persistent
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import { useDate } from "vuetify";

export default {
  data() {
    return {
      dateMenu: false,
      dayStr: "",
      day: 0,
      semesterSettings: null,
      selectedDate: null,
      departments: [],
      selectedDept: null,
      processData: false,
      attColumns: [],
      headers: [],
      flatItems: [],

      expandedGroups: new Set(),

      totalAttendance: {},

      emojis: {
        УП: "&#128526;",
        Б: "&#129298;",
        НП: "&#128121;",
        ОТ: "&#128123;",
        ОП: "&#128561;",
        ОСВ: "&#129395;",
      },
    };
  },

  watch: {
    day(newVal) {
      this.dayStr = this.day.toLocaleDateString("ru-RU", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      if (this.selectedDept) this.getMissedHours(this.selectedDept);
    },
    selectedDate(newVal) {
      this.day = new Date(newVal);
    },
  },

  created() {
    this.loadSemesterSettings();
    this.getDepartments();
  },

  methods: {
    getDepartments() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/reportsLocal/summaryMissedHours/getDepartments"
        )
        .then((r) => (this.departments = r.data));
    },

    loadSemesterSettings() {
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/core_procollege/helpers/TimetableHelper/timetableGetSemesterDates"
        )
        .then((r) => (this.semesterSettings = r.data));

      this.day = new Date();
      this.dateFormatter = useDate();
      this.processData = false;
    },

    incDate() {
      this.day = new Date(this.day.setDate(this.day.getDate() + 1));
    },
    decDate() {
      this.day = new Date(this.day.setDate(this.day.getDate() - 1));
    },
    getMissedHours(deptid) {
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/reportsLocal/summaryMissedHours/getMissedHours",
          new URLSearchParams({
            dayStr: this.day.toLocaleDateString("en-US"),
            departmentid: deptid,
          })
        )
        .then((response) => {
          const groups = response.data.groups;
          this.attColumns = response.data.attendance;
          this.totalAttendance = response.data.totalsAll;

          this.headers = [
            { title: "Группа", key: "group_name", sortable: false },
            { title: "ФИО", key: "student_name", sortable: false },
            ...this.attColumns.map((a) => ({
              title: a,
              key: a,
              sortable: false,
            })),
          ];

          this.flatItems = [];

          groups.forEach((g) => {
            // строка группы
            this.flatItems.push({
              type: "group",
              groupid: g.groupid,
              group_name: g.group_name,
            });

            // студенты
            g.students.forEach((s) => {
              this.flatItems.push({
                type: "student",
                groupid: g.groupid,
                student_name: s.student_name,
                ...s, // УП, Б, НП...
              });
            });

            // итог группы
            this.flatItems.push({
              type: "total",
              groupid: g.groupid,
              ...g.total,
            });
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.processData = false;
        });
    },

    toggleGroup(id) {
      if (this.expandedGroups.has(id)) this.expandedGroups.delete(id);
      else this.expandedGroups.add(id);
      this.expandedGroups = new Set(this.expandedGroups);
    },
    isExpanded(id) {
      return this.expandedGroups.has(id);
    },

    printExcel() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/reportsLocal/summaryMissedHours/printExcelReport",
          new URLSearchParams({
            dayStr: this.day.toLocaleDateString("en-US"),
            departmentid: this.selectedDept,
          }),
          { responseType: "blob" }
        )
        .then((response) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);
          link.download = "summaryMissedHours.xlsx";
          link.click();
        });
    },
  },
};
</script>

  
  <style>
.attendance-table .v-table__wrapper {
  overflow-y: auto !important;
}

.group-row {
  background: #f0f0f0;
}

.attendance-table table {
  border-collapse: collapse;
}
</style>
  